"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _SecurityContextHolder = require("../../api/SecurityContextHolder");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MenuCards = _ref => {
  let {
    menuItems,
    images
  } = _ref;
  let menuItemList = [];
  let mainMenuItemList = [];
  if (_SecurityContextHolder.SecurityContextHolder.isAuthenticated() && _SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu) {
    menuItemList = _SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu.getChildren('MegaCard-Menu-Links');
    mainMenuItemList = _SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu.getChildren('Main-Menu-Links');
    mainMenuItemList = mainMenuItemList.filter(item => typeof item.visible !== 'undefined' && item.visible);
  }
  if (menuItems && menuItems.length > 0) {
    menuItemList = menuItems;
  }
  if (mainMenuItemList.length <= 1 && menuItemList.length === 0) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "menu-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cards"
  }, menuItemList.filter(menuItem => typeof menuItem.visible !== 'undefined' && menuItem.visible).map(menuItem => /*#__PURE__*/_react.default.createElement("div", {
    className: "card has-background-white pt-0",
    key: `mcard_${menuItem.id}`
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: "card-header"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "title has-text-info"
  }, menuItem.name || menuItem.title), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
    className: "subtitle is-6 has-text-grey"
  }, menuItem.name !== menuItem.title ? menuItem.title : menuItem.description)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    to: menuItem.path,
    activeClassName: "is-active",
    className: "button is-primary is-small",
    key: `card_${menuItem.id}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons has-text-weight-bold"
  }, "keyboard_arrow_right")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "card-image"
  }, /*#__PURE__*/_react.default.createElement("figure", {
    className: "image is-2by1"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: images[menuItem.image],
    alt: menuItem.imageAlt
  })))))));
};
MenuCards.propTypes = {
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    children: _propTypes.default.array,
    description: _propTypes.default.string,
    icon: _propTypes.default.string,
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    image: _propTypes.default.string,
    imageAlt: _propTypes.default.string,
    path: _propTypes.default.string,
    title: _propTypes.default.string,
    visible: _propTypes.default.bool
  }))
};
MenuCards.defaultProps = {
  menuItems: []
};
var _default = exports.default = MenuCards;
//# sourceMappingURL=MenuCards.js.map